const o = "Thông báo", t = "Thông báo quan trọng", i = "Đóng thông báo", n = {
  notification: o,
  criticalNotification: t,
  close: i
};
export {
  i as close,
  t as criticalNotification,
  n as default,
  o as notification
};
